import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule, NgForm } from '@angular/forms';
import { UnblockUserService } from '../../../services/unblock-user/unblock-user.service';
import { UnblockUserRequest } from '../../../interfaces/unblock-user.interface';
import { CommonModule } from '@angular/common';
import { ErrorAlertComponent } from "../../shared/error-alert/error-alert.component";
import { LoadingService } from '../../../services/general/loading.service';
import { SuccessAlertComponent } from "../../shared/success-alert/success-alert.component";
import { ConfirmationModalComponent } from "../../shared/confirmation-modal/confirmation-modal.component";
import { LogTackingService } from '../../../services/logs/log-tacking.service'
import { LogsTrackingRequest, LogsTrackingResponse } from '../../../interfaces/logs_tracking.interface.';
import { PageHeaderComponent } from '../../shared/page-header/page-header.component';


@Component({
  selector: 'app-unblock-user',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, FormsModule, ErrorAlertComponent, SuccessAlertComponent, ConfirmationModalComponent, PageHeaderComponent],
  templateUrl: './unblock-user.component.html',
  styleUrl: './unblock-user.component.css'
})
export class UnblockUserComponent {
  token: string = '';
  nitInput: string = '';
  username: string = '';
  errorMessage: string = '';
  successMessage: string = '';
  showAlertError: boolean = false
  showAlerSuccess: boolean = false
  message1ForSuccesAlert = 'Desbloqueo exitoso'
  message2ForSuccesAlert = ''
  isModalVisible: boolean = false;
  log_info: LogsTrackingRequest = {
    email: localStorage.getItem('userName') ?? '',
    action: 'Desbloquear Usuario',
    details: '',
    ip_address: localStorage.getItem('ip') ?? ''
  }

  constructor(
    private unblockUserService: UnblockUserService,
    private _logsService: LogTackingService,
    private _loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.token = localStorage.getItem('authToken') ?? '';
  }

  onSubmit(form: NgForm) {
    this.isModalVisible = true
  }
  cancel(form: NgForm) {
    this.nitInput = '';
    this.username = '';
    form.resetForm();
  }
  showErrorComponent(form: NgForm) {
    this._loadingService.setLoading(false);
    this.createTrackingLog()
    this.showAlertError = true
    setTimeout(() => {
      this.showAlertError = false;
      this.cancel(form)
    }, 5000);
  }

  onConfirm(form : NgForm) {
    this._loadingService.setLoading(true)
    let haveNit= this.username.substring(0,3) 
    if( haveNit !== 'nit'){
      this.username = (`nit-${this.nitInput}-${this.username}`).trim()
    }
    this.unblockUserService.unblockUser(this.token, this.nitInput, this.username)
      .subscribe({
        next: (response) => {
          this.showAlerSuccess = true
          this._loadingService.setLoading(false)
          this.message2ForSuccesAlert = `El usuario ${this.username} se ha desbloqueado correctamente.`
          this.log_info.details = `Success: Usuario desbloqueo el usuario ${this.username}`
          this.createTrackingLog()
          setTimeout(() => {
            this.showAlerSuccess = false;
            this.cancel(form);
          }, 5000);
        },
        error: (error) => {
          this.errorMessage = "Error al desbloquear usuario."
          this.log_info.details = `Error: ${this.errorMessage}`
          this.showErrorComponent(form)

        }
      });
    this.isModalVisible = false;
  }

  createTrackingLog() {
    this._logsService.generateTrackingLog(this.log_info).subscribe({
      next: (response: LogsTrackingResponse) => { },
      error: (error) => {
        console.log(error);
      }
    });
  }

  onCancel() {
    location.reload()
    this.isModalVisible = false;
  }
}
